module.exports = __webpack_public_path__ + "static/media/rr-qrcode.bf3d8e61.svg";